import { render } from "./picture-form.vue?vue&type=template&id=6455d9e8&scoped=true"
import script from "./picture-form.vue?vue&type=script&lang=js"
export * from "./picture-form.vue?vue&type=script&lang=js"

import "./picture-form.vue?vue&type=style&index=0&id=6455d9e8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6455d9e8"]])

export default __exports__